
<img [src]="avatar || '/assets/avatar.png'" />
<br />
{{fullName}}
<br /><br />
<a href="#" (click)="back($event)">Back</a>
